import type { SVGProps } from 'react';

const SvgNavigationCdp = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 12" {...props}>
    <path
      fill={props.color}
      fillRule="evenodd"
      d="M2.387 4.122C2.737 1.798 4.782 0 7.275 0c2.74 0 4.94 2.176 4.94 4.833 0 .273-.022.54-.067.801C13.253 6.2 14 7.331 14 8.625 14 10.477 12.466 12 10.546 12v-.001A.773.773 0 0 1 10.5 12H4.09C1.79 12 0 10.114 0 7.875c0-1.643.965-3.096 2.387-3.753zM4.07 3.75A3.386 3.386 0 0 1 7.275 1.5c1.857 0 3.385 1.48 3.385 3.333 0 .301-.04.592-.115.867l-.009.031-.162.902.676.184a1.88 1.88 0 0 1 1.394 1.808c0 1.048-.862 1.875-1.898 1.875v.001a.773.773 0 0 0-.046-.001H4.09c-1.36 0-2.534-1.136-2.534-2.625S2.73 5.25 4.09 5.25c.486 0 .94.141 1.329.39l.564.48c.309.264.776.249 1.067-.033s.303-.732.028-1.028A4.05 4.05 0 0 0 4.071 3.75z"
      clipRule="evenodd"
    />
  </svg>
);

export default SvgNavigationCdp;
